export enum PagePath {
    Home = `/home`,
    AuthLogin = `/login`,
    AuthSignUp = `/signup`,
    Chart = `/chart`,
};